import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import logger from 'redux-logger';

import rootReducer from './root-reducer';

const middlewares = [thunk];

if (process.env.NODE_ENV === 'development') {
  middlewares.push(logger);
}

export default (initState) => {
  const store = createStore(
    rootReducer,
    initState,
    applyMiddleware(...middlewares)
  );
  return store;
};
